import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Languages } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const { t, lang, setLang } = useI18n();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <img src="/logo512.png" alt="AB" data-testid="login-logo" className="rise w-40 h-40 sm:w-48 sm:h-48 object-contain" />
      <div className="rise text-xl sm:text-2xl font-extrabold text-[#3E3E40] mt-2 mb-8 text-center" data-testid="login-app-name">{t("appName")}</div>
      <div className="w-full max-w-md">
        <form onSubmit={submit} className="rise w-full bg-white space-y-5" data-testid="login-form">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-extrabold">{t("login")}</h2>
            <Button type="button" variant="outline" size="sm" data-testid="login-lang-toggle" onClick={() => setLang(lang === "ar" ? "en" : "ar")}><Languages className="w-4 h-4" />{lang === "ar" ? "EN" : "ع"}</Button>
          </div>
          <div className="space-y-2">
            <Label>{t("email")}</Label>
            <Input data-testid="login-email-input" type="email" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label>{t("password")}</Label>
            <Input data-testid="login-password-input" type="password" dir="ltr" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full h-11" disabled={busy} data-testid="login-submit-btn">{t("login")}</Button>
        </form>
      </div>
    </div>
  );
}
